module.exports = "/images/sophia-av.webp?1f7cbf697e23490cda0e0b8cf297fa6d";